import { Statistic } from '@/components/_common';
import { DirectSaleStatisticsResponse } from '@/core/domain/sales/DirectSale/DirectSale.types';
import { Card, Col, Row } from 'antd';

interface Props {
  directSaleStatistics?: DirectSaleStatisticsResponse;
}

const DirectSaleStatistics: React.FC<Props> = ({
  directSaleStatistics: statistics,
}) => {
  const formmaterPrince = (value?: number) =>
    (value || 0).toLocaleString('pt-br', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      currency: 'BRL',
      style: 'currency',
    });

  return (
    <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
      <Col span={24} md={12} lg={8} xl={6}>
        <Card bodyStyle={{ padding: 16 }} style={{ borderRadius: 4 }}>
          <Statistic
            title="Total no período"
            value={formmaterPrince(statistics?.totalSaleRevenue)}
          />
        </Card>
      </Col>

      <Col span={24} md={12} lg={8} xl={6}>
        <Card bodyStyle={{ padding: 16 }} style={{ borderRadius: 4 }}>
          <Statistic
            title="Autorizados no período"
            value={formmaterPrince(statistics?.authorizedSaleRevenue)}
            valueStyle={{ color: 'hsl(154, 70%, 50%)' }}
          />
        </Card>
      </Col>

      <Col span={24} md={12} lg={8} xl={6}>
        <Card bodyStyle={{ padding: 16 }} style={{ borderRadius: 4 }}>
          <Statistic
            title="Abertos no período"
            value={formmaterPrince(statistics?.openSaleRevenue)}
            valueStyle={{ color: 'hsl(200, 100%, 50%)' }}
          />
        </Card>
      </Col>

      <Col span={24} md={12} lg={8} xl={6}>
        <Card bodyStyle={{ padding: 16 }} style={{ borderRadius: 4 }}>
          <Statistic
            title="Cancelados no período"
            value={formmaterPrince(statistics?.canceledSaleRevenue)}
            valueStyle={{ color: 'hsl(0, 90%, 60%)' }}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default DirectSaleStatistics;
